import { useEffect, useState } from "react";

const useReportGroupFetch = (reload: object, user: any) => {
    const [reportGroupLoading, setLoading] = useState(true);
    const [reportGroups, setData] = useState([]);
    let token = localStorage.getItem('token')
    const url = process.env.REACT_APP_BACKEND_URL

    const fetchData = async (language = null) => {
        try {

            const response = fetch(`${url}/report-groups`,  {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
            }).then((res:any) => {
                return res.json();
            }).then((a:any) => {
                setData(a)
                setLoading(false);
            });
        } catch (error) {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [reload]);

    return { reportGroupLoading, setLoading, reportGroups, setData, fetchData };
};

export default useReportGroupFetch;
